import { ReactNode, useState } from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Pagination } from "swiper/modules";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";
import { useHomePageContext } from "@/src/features/home/HomePageContext";
import { useEffectOnce } from "react-use";
import DOMPurify from "isomorphic-dompurify";
import { Article } from "@/lib/types/Article";

const AnnouncementCards = (): ReactNode => {
  const { announcements } = useHomePageContext();

  return (
    <Swiper
      className="swiper-wrapper align-items-center"
      effect={"cards"}
      modules={[EffectCards, Pagination]}
      grabCursor={true}
      pagination={{
        el: ".rbt-swiper-pagination",
        clickable: true
      }}
    >
      {announcements.map(item => (
        <SwiperSlide className="swiper-slide" key={item.IdGuid}>
          <SlideItem item={item} />
        </SwiperSlide>
      ))}
      <div className="rbt-swiper-pagination"></div>
    </Swiper>
  );
};

const SlideItem = ({ item }: { item: Article }) => {
  const [sanitizedContent, setSanitizedContent] = useState<string>("");
  const { t } = useTranslation();
  const routes = useBrowserRoutes();
  const detailLink = routes.announcementDetail.replace(":slug", item.Slug);

  useEffectOnce(() => {
    setSanitizedContent(DOMPurify.sanitize(item.Content, { USE_PROFILES: { html: false } }));
  });

  return (
    <div className="rbt-card variation-01 rbt-hover">
      <div className="rbt-card-img">
        <Link href={detailLink}>
          <Image
            src={item.ThumbImageUrl}
            width={330}
            height={220}
            alt={item.ImageAltText}
            style={{
              height: 220,
              objectFit: "cover"
            }}
          />
        </Link>
      </div>
      <div className="rbt-card-body">
        <ul className="rbt-meta">
          <li>{item.Category.Name}</li>
        </ul>
        <h4 className="rbt-card-title">
          <Link href={detailLink}>{item.Title}</Link>
        </h4>
        <p className="rbt-card-text text-multiline-ellipsis-6" dangerouslySetInnerHTML={{ __html: sanitizedContent }}></p>
        <div
          className="rbt-card-bottom"
          style={{
            justifyContent: "flex-end"
          }}
        >
          <Link className="rbt-btn-link" href={detailLink}>
            {t("announcemenDetails")}
            <i className="feather-arrow-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementCards;
